var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentDankortLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 28,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31557_25379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5411 0.703125C6.22432 0.703125 0.271484 6.6647 0.271484 13.9924C0.271484 21.3209 6.22432 27.283 13.5411 27.283H31.4114C38.7272 27.283 44.6792 21.3209 44.6792 13.9924C44.6792 6.6647 38.7272 0.703125 31.4114 0.703125H13.5411Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.541 0.703584C6.22424 0.703584 0.271411 6.66516 0.271411 13.9929C0.271411 21.3213 6.22424 27.2835 13.541 27.2835H31.4114C38.7272 27.2835 44.6792 21.3213 44.6792 13.9929C44.6792 6.66516 38.7272 0.703584 31.4114 0.703584H13.541ZM31.4114 27.5534H13.541C6.07555 27.5534 0.00195312 21.4702 0.00195312 13.9929C0.00195312 6.51632 6.07555 0.433594 13.541 0.433594H31.4114C38.8759 0.433594 44.9486 6.51632 44.9486 13.9929C44.9486 21.4702 38.8759 27.5534 31.4114 27.5534Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.696 6.83499H5.15844C7.18157 4.4627 10.1885 2.95605 13.5408 2.95605H31.4111C34.7622 2.95605 37.7686 4.4627 39.7916 6.83442H30.4919L25.8215 11.711C25.4774 7.96593 22.1337 6.83499 17.696 6.83499ZM34.5351 13.1817L40.2669 7.43252C41.6258 9.26772 42.4311 11.5382 42.4311 13.9933C42.4311 16.3195 41.7082 18.4789 40.4775 20.2604L34.5351 13.1817ZM10.3843 11.5561H16.1537C17.4454 11.5561 18.4969 12.1352 18.0783 13.6277C17.6553 15.1366 17.0834 15.9203 15.1933 15.9203H8.79958L10.3843 11.5561ZM30.5307 20.8563H40.0361C38.0154 23.3994 34.9001 25.0323 31.4112 25.0323H13.5407C10.0506 25.0323 6.93467 23.3987 4.91406 20.8555H16.0835C21.6879 20.8555 24.6775 18.8668 25.5913 14.6037L30.5307 20.8563Z",
    fill: "#E21F28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31557_25379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDankortLogo);
export default __webpack_public_path__ + "static/media/payment-dankort-logo.cb75d735aaca325cb9b5800881af3df6.svg";
export { ForwardRef as ReactComponent };